import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { fetchHomeProduct } from '../../../redux/action/product/getProduct'
import MainLoading from '../../../utils/MainLoading'
import HomeMainTitle from '../../homeTitle/HomeMainTitle'
import Wrapper from '../../homeWrapper/Wrapper'
import ImageGallery from 'react-image-gallery';
import default_image_url from '../../../redux/api/API'
import {IoMdPricetags} from 'react-icons/io'
import {MdProductionQuantityLimits} from 'react-icons/md'
import {AiOutlineNumber} from 'react-icons/ai'
import './style.scss'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

const Product = (props) => {
    const [images, setImages] = useState([])
    const [btnLoading, setBtnLoading] = useState(false)
    const {t} = useTranslation();

    const dispatch = useDispatch()
    const home_product = useSelector(state => state.home_product)
    const lang = localStorage.getItem('lang')

    useEffect(() => {
        dispatch(fetchHomeProduct(props.match.params.id))
        axios.get(`p/product/${props.match.params.id}`)
        .then(res => {
            setImages(res.data.photos.map(item => (
                {
                    original: default_image_url+item.large_path,
                    thumbnail: default_image_url+item.small_path,
                }
            )))
        })
        .catch(err => console.log(err))
    }, [])

    return (
        <Wrapper>
            <div className='product-container'>
                {home_product.loading ? 
                    <MainLoading />                
                :
                home_product.home_product.name &&
                    <Container className='mt-5'>
                        <Helmet>
                            <title>{home_product.home_product.name} - نمایشگاه مجازی</title>
                        </Helmet>
                        <HomeMainTitle>
                            {home_product.home_product.name}
                        </HomeMainTitle>
                        <Row>
                            {home_product.home_product.photos &&
                                home_product.home_product.photos.length ?
                                    <div className='col-md-5 mt-5 product-page-images'>
                                        <ImageGallery items={images} showPlayButton={false} isRTL={lang === 'en' ? false : true} />
                                    </div>
                                :
                                    ''
                            }
                            <div className='col-md-7 mt-5'>
                                <div className='product-page-info'>
                                    <div className='mb-3 d-flex'>
                                        <h6><MdProductionQuantityLimits size='1.5em' />{t("product_brand")} : </h6>
                                        <h3>{home_product.home_product.brand}</h3>
                                    </div>
                                    <div className='mb-3 d-flex'>
                                        <h6><IoMdPricetags size='1.5em' /> {t("product_price")}: </h6>
                                            {home_product.home_product.price !== home_product.home_product.sell_price ?
                                                <>
                                                    <span style={{textDecoration: 'line-through', margin: '0 .5rem'}}>{parseInt(home_product.home_product.price).toLocaleString()}</span> 
                                                    <h3>{parseInt(home_product.home_product.sell_price).toLocaleString()} {lang === 'en' ? 'Rial' : 'ریال'}</h3>
                                                </>
                                            :
                                                <>
                                                    <h3 style={{margin: '0 .5rem'}}>{parseInt(home_product.home_product.sell_price).toLocaleString()} {lang === 'en' ? 'Rial' : 'ریال'}</h3>
                                                </>
                                            }
                                    </div>
                                    <div className='mb-3 d-flex'>
                                        <h6><AiOutlineNumber size='1.5em' /> {t("product_unit")}: </h6>
                                        <h3>{home_product.home_product.unit}</h3>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-end'>
                                    <button className='btn purple-btn px-5'> {t("buy")} </button>
                                </div>
                            </div>
                        </Row>
                    </Container>
                }
                </div>
        </Wrapper>
    )
}

export default Product
